export default "__VITE_ASSET__DRpBV07N__"